import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_2 = {
  class: "modal-content",
  style: {"max-height":"100vh","max-width":"95vw"}
}
const _hoisted_3 = {
  key: 0,
  class: "progress is-primary",
  max: "100"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "tag is-primary" }
const _hoisted_6 = { class: "image is-square" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "modal-close is-large has-background-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal is-active",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          (_ctx.progress)
            ? (_openBlock(), _createElementBlock("progress", _hoisted_3))
            : (_openBlock(), _createElementBlock("figure", _hoisted_4, [
                _createElementVNode("figcaption", _hoisted_5, _toDisplayString(_ctx.caption), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.image_src,
                    alt: "Kalender-Bild"
                  }, null, 8, _hoisted_7)
                ])
              ]))
        ]),
        (!_ctx.progress)
          ? (_openBlock(), _createElementBlock("button", _hoisted_8))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}